import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import LeafletNearestDrivers from '../../Components/LeafletNearestDrivers';
import axios from 'axios';

const Shipping = () => {
    const { idTrx } = useParams();

    const [coordinateDriver, setCoordinateDriver] = useState<{ latitude: number; longitude: number } | null>(null);
    const [coordinateCustomer, setCoordinateCustomer] = useState<{ latitude: number; longitude: number } | null>(null);

    useEffect(() => {
        const fetchTransactionDetail = async () => {
            try {
                const token = localStorage.getItem('token');
                const res = await axios.get(`${process.env.REACT_APP_HOST_INTELLIKASIR}/api/v1/transaction/mp/${idTrx}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                const trx = res.data.data;

                if (trx?.courier_name_latitude && trx?.courier_name_longitude && trx?.user_name_latitude && trx?.user_name_longitude) {
                    setCoordinateDriver({
                        latitude: trx.courier_name_latitude,
                        longitude: trx.courier_name_longitude,
                    });
                    setCoordinateCustomer({
                        latitude: trx.user_name_latitude,
                        longitude: trx.user_name_longitude,
                    });
                }
            } catch (error) {
                console.error('Failed to fetch transaction detail', error);
            }
        };

        if (idTrx) fetchTransactionDetail();
    }, [idTrx]);

    return (
        <>
            {coordinateCustomer && coordinateDriver && (
                <LeafletNearestDrivers
                    isShowHandleDriverClick={false}
                    customer={coordinateCustomer}
                    drivers={[coordinateDriver]}
                    isReverseGeocode={false}
                    zoom={12}
                    height="100vh"
                />
            )}
        </>
    );
};

export default Shipping;
